import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import Security from '../../../commons/security/Security.js';
import ReglasOciosidadV2Card from './ReglasOciosidadV2Card.jsx';
import DisponibilidadReglasGrid from './DisponibilidadReglasGrid.jsx';
import DisponibilidadReglasAbm from './DisponibilidadReglasAbm.js';

const PERMISO_RENTADORA_LISTAR = 'DISPONIBILIDAD_REGLAS_LISTAR';
const PERMISO_OCIOSIDAD_V2_LISTAR = 'DISPONIBILIDAD_REGLAS_OCIOSIDAD_V2_LISTAR';

class Reglas extends Component {
  render() {
    if (!Security.hasAnyPermission([PERMISO_RENTADORA_LISTAR, PERMISO_OCIOSIDAD_V2_LISTAR])) {
      return <Redirect to="/error" />;
    }

    return (
      <div className="content-wrapper">
        <div className="content-header row">
          <div className="content-header-left col-md-6 col-12 mb-2">
            <h3 className="content-header-title">
              <Switch>
                <Route
                  path={this.props.match.url + '/ociosidad'}
                  render={() => <FormattedMessage id="reglas.ociosidad.titulo" defaultMessage="Reglas de Ociosidad" />}
                />
                <Route
                  render={() => <FormattedMessage id="reglas.rentadora.titulo" defaultMessage="Reglas de Rentadora" />}
                />
              </Switch>
            </h3>
          </div>
        </div>
        <div className="content-body">
          <Switch>
            <Route
              exact
              path={this.props.match.url + '/ociosidad'}
              render={() => (
                Security.hasPermission(PERMISO_OCIOSIDAD_V2_LISTAR)
                  ? <ReglasOciosidadV2Card />
                  : <Redirect to="/error" />
              )}
            />
            <Route
              exact
              path={this.props.match.url}
              render={() => (
                Security.hasPermission(PERMISO_RENTADORA_LISTAR)
                  ? <DisponibilidadReglasGrid {...this.props} />
                  : <Redirect to="/error" />
              )}
            />
            <Route
              exact
              path={this.props.match.url + '/add'}
              render={(props) => <DisponibilidadReglasAbm {...props} action="ADD" />}
            />
            <Route
              exact
              path={this.props.match.url + '/:id/edit'}
              render={(props) => <DisponibilidadReglasAbm {...props} action="EDIT" />}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

export default injectIntl(Reglas);
